<template>
  <div
    class="d-flex border-top"
    style="min-height: 250px">
    <div style="background-color: #f4f5f7">
      <div
        class="d-flex justify-content-between px-12 py-2 filter-react pointer"
        style="width: 100px"
        @click="onSelectReaction(null)"
        :class="selectType === null && 'active-filter-react'">
        <span>Tất cả</span>
        <span>{{ reactionList.length }}</span>
      </div>
      <div
        v-for="react in groupByReactionType"
        :key="react[0].rType">
        <div
          class="d-flex justify-content-between px-12 py-2 filter-react pointer"
          :class="selectType === react[0].rType && 'active-filter-react'"
          @click="onSelectReaction(react[0].rType, react)"
          style="width: 100px">
          <img
            :src="getReactType(react[0].rType).src"
            width="20px" />
          <span>{{ react.length }}</span>
        </div>
      </div>
    </div>
    <div class="ps-2 pe-3 py-2 w-100">
      <div
        v-for="member in groupByUid"
        :key="member.uidFrom"
        class="d-flex align-items-center justify-content-between flex-grow-1 mb-2">
        <div class="d-flex align-items-center">
          <img
            style="width: 40px; height: 40px; border-radius: 20px"
            :src="getMember(member[0].uidFrom)?.avatar || '/assets/images/no-avatar.png'" />
          <span class="ms-2">{{ getMember(member[0].uidFrom).name }}</span>
        </div>
        <div class="d-flex align-items-center text-grey900">
          <img
            v-if="member.find((r) => r.content.rType === 3)"
            src="/assets/icon/Emoji-like.svg"
            class="me-1"
            width="16px" />
          <img
            v-if="member.find((r) => r.content.rType === 5)"
            src="/assets/icon/Emoji-heart.svg"
            class="me-1"
            width="16px" />
          <img
            v-if="member.find((r) => r.content.rType === 0)"
            src="/assets/icon/Emoji-smile.svg"
            class="me-1"
            width="16px" />
          <img
            v-if="member.find((r) => r.content.rType === 32)"
            src="/assets/icon/Emoji-oh.svg"
            class="me-1"
            width="16px" />
          <img
            v-if="member.find((r) => r.content.rType === 2)"
            src="/assets/icon/Emoji-cry.svg"
            class="me-1"
            width="16px" />
          <img
            v-if="member.find((r) => r.content.rType === 20)"
            src="/assets/icon/Emoji-angry.svg"
            class="me-1"
            width="16px" />
          <span class="font-13 text-grey600 lh-sm">
            {{ member.length }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reactionList", "conversation", "members"],
  data() {
    return {
      selectReaction: [],
      selectType: null,
    };
  },
  computed: {
    groupByReactionType() {
      const reactListParseContent = this.reactionList.map((r) => ({
        ...r,
        rType: r.content.rType,
      }));
      return this.groupBy(reactListParseContent, "rType");
    },
    groupByUid() {
      const selectReaction = this.selectReaction.length ? this.selectReaction : this.reactionList;
      return this.groupBy(selectReaction, "uidFrom");
    },
    reactionTypeList() {
      return [
        { icon: "/-strong", type: 3, src: "/assets/icon/Emoji-like.svg" },
        { icon: "/-heart", type: 5, src: "/assets/icon/Emoji-heart.svg" },
        { icon: ":>", type: 0, src: "/assets/icon/Emoji-smile.svg" },
        { icon: ":o", type: 32, src: "/assets/icon/Emoji-oh.svg" },
        { icon: ":-((", type: 2, src: "/assets/icon/Emoji-cry.svg" },
        { icon: ":-h", type: 20, src: "/assets/icon/Emoji-angry.svg" },
      ];
    },
    currentAcc() {
      const currentAcc = this.app.accounts.find((a) => a.accountId === this.conversation.accountId);
      return currentAcc;
    },
  },
  methods: {
    groupBy(arr, field) {
      const groups = {};
      arr.forEach((item) => {
        const value = item[field];
        if (!groups[value]) {
          groups[value] = [];
        }
        groups[value].push(item);
      });
      return Object.values(groups);
    },
    getReactType(type) {
      const rType = this.reactionTypeList.find((r) => r.type === type);
      return rType;
    },
    onSelectReaction(type, list) {
      this.selectType = type;
      if (list) {
        this.selectReaction = list;
      } else {
        this.selectReaction = this.reactionList;
      }
    },
    getMember(uidFrom) {
      if (uidFrom == "0") {
        return {
          accountId: this.currentAcc.accountId,
          id: "0",
          name: "Bạn",
          avatar: this.currentAcc.avatar,
        };
      } else {
        if (this.conversation.group) {
          const member = this.members.find((m) => m.id == uidFrom);
          return member;
        } else {
          return {
            accountId: this.conversation.accountId,
            id: this.conversation.toId,
            name: this.conversation.toName,
            avatar: this.conversation.avatar,
          };
        }
      }
    },
  },
  mounted() {},
};
</script>

<style>
.active-filter-react {
  background-color: #e6efff;
  font-weight: 500;
}
.filter-react:hover {
  background-color: #e6efff;
}
</style>